import { Diagnostics } from "../models/diagnostics-model";

export function getDiagnostics(): Diagnostics | undefined {
    try {
        // For details see https://learn.microsoft.com/en-us/javascript/api/outlook/office.mailbox?view=outlook-js-1.13#outlook-office-mailbox-diagnostics-member
        // Note the mailbox can be null, e.g. if called from AttachFilesPage
        const mailboxDiagnostics = Office.context.mailbox?.diagnostics;

        // For details see https://learn.microsoft.com/en-us/javascript/api/office/office.context?view=common-js-preview
        const runtimeDiagnostics = Office.context.diagnostics;

        return {
            platform: runtimeDiagnostics?.platform?.toString(),
            version: runtimeDiagnostics?.version,
            hostName: mailboxDiagnostics?.hostName,
            hostVersion: mailboxDiagnostics?.hostVersion
        };
    } catch (error) {
        console.error("Error retrieving diagnostics:", error);
        return undefined;
    }
}